"use strict";
import React from "react";
import { Box, Button, TextField, Typography } from "@mui/material";

const VoiceSandbox = ({ selectedVoice }) => {
    const voiceId = selectedVoice?.voiceId || null;
    const projectId = selectedVoice?.projectId || null;

    const handleGenerate = () => {
        alert("TODO");
    };

    return (
        <Box sx={{ maxWidth: 800, display: "flex", flexDirection: "column", gap: 2 }}>
            <Box>
                <Typography variant="h5" sx={{ mb: 0.5 }}>
                    Voice Sandbox
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                    {selectedVoice
                        ? `Project: ${projectId || "Unknown project"} · Voice: ${voiceId || "Unknown voice"}`
                        : "Select a voice from the catalogue to start a sandbox session."}
                </Typography>
            </Box>

            <TextField
                label="Input Text"
                placeholder="Enter the lines you want to synthesize"
                multiline
                minRows={4}
                fullWidth
                disabled={!selectedVoice}
                sx={{ backgroundColor: "background.paper" }}
            />

            <Button
                variant="contained"
                onClick={handleGenerate}
                disabled={!selectedVoice}
                sx={{ alignSelf: "flex-start" }}
            >
                Generate
            </Button>
        </Box>
    );
};

export default VoiceSandbox;
